import { ENTITY_TYPE } from '../../../constants'

/**
 * Bump when the decode/mapping logic changes in a way that requires re-seeding
 * previously-seeded businesses. Stored per-business in `business_seed_metadata`
 * and compared on boot; a mismatch triggers a fresh seed.
 *
 * v2: the create/edit write-through (release #4351) cached rows with the wrong
 * `amount` unit and a missing `type`, so web-added transactions rendered as e.g.
 * ₹0.12 instead of ₹12 and on the wrong credit/payment side. The mapping is fixed,
 * but rows already written wrong stay stuck in IndexedDB — the delta refresh never
 * re-pulls them once the cursor advances past their update_time. Bumping forces a
 * one-time re-seed that re-downloads the authoritative history and REPLACES the
 * corrupt local rows (bulkStoreTransactions overwrites each account's whole array).
 */
export const SEED_VERSION = 2

/**
 * `account_type` discriminator sent to GetTransactionsForLogin — one file per
 * type. Mirrors Android (customer = 0, supplier = 1). CONFIRM with backend.
 */
export enum SEED_ACCOUNT_TYPE {
  CUSTOMER = 0,
  SUPPLIER = 1
}

export const SEED_ACCOUNT_TYPES: SEED_ACCOUNT_TYPE[] = [
  SEED_ACCOUNT_TYPE.CUSTOMER,
  SEED_ACCOUNT_TYPE.SUPPLIER
]

export const seedAccountTypeToEntityType = (accountType: SEED_ACCOUNT_TYPE): ENTITY_TYPE =>
  accountType === SEED_ACCOUNT_TYPE.SUPPLIER ? ENTITY_TYPE.SUPPLIER : ENTITY_TYPE.CUSTOMER

/**
 * Poll GetTransactionFile until ready. Mirrors Android exactly: `delay(min(2000,
 * attempt * 200))` before each request (200ms → 2000ms, then capped), UNBOUNDED —
 * polls until status === 1 or an API error propagates.
 */
export const SEED_FILE_POLL = {
  stepMs: 200,
  maxDelayMs: 2000
}
